import { queryOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import type { DepartmentDto } from './models';

export const departmentsQueryOptions = queryOptions({
  queryKey: ['部门列表'],
  queryFn: () => {
    return http.get('departments').json<DepartmentDto[]>();
  },
});
